module.exports = __webpack_public_path__ + "static/media/reports.bdbf0fec.png";